module.exports = __webpack_public_path__ + "img/forming_1200x800.3af61255.svg";